import React from "react";

const ChatSidebar = ({
  conversations,
  activeChat,
  onSelectChat,
  onNewChat,
  onDeleteChat,
  conversationNames,
  isGenerating
}) => {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="status-container">
          <h4>{isGenerating ? 'AI Agent Generating' : 'AI Agent Active'}</h4>
          <span className={`ready-badge ${isGenerating ? 'generating' : ''}`}>
            {isGenerating ? 'Generating' : 'Ready'}
          </span>
        </div>
        <p className="sidebar-subtitle">Welcome to SOSTOS AI Agent</p>
      </div>

      <div className="new-chat-section">
        <h5>Start a new chat</h5>
        <button className="new-chat-btn" onClick={onNewChat}>
          + New AI analysis
        </button>
      </div>

      <div className="recent-chats-section">
        <h5>Recent chats</h5>
        <div className="conversation-list">
          {conversations.length === 0 && (
            <p className="empty-sidebar">No chats yet</p>
          )}

          {conversations.map((id) => (
            <div
              key={id}
              className={`conversation-tab ${activeChat === id ? "active" : ""}`}
              onClick={() => onSelectChat(id)}
            >
              <span className="tab-title">{conversationNames[id] || id}</span>
              <button
                className="delete-chat-btn"
                onClick={(e) => onDeleteChat(e, id)}
                title="Delete Chat"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChatSidebar;
